import { Actor, SpriteSheet, TileMap, Vector } from "excalibur";
import { Resources } from "../../Resources";
import {
  broodFrames,
  emptyFrame,
  honeyFrame,
  partialBrood,
  partialHoney,
} from "../../frameConstants";

export default class Frame extends TileMap {
  constructor(frameObject, scene) {
    super({
      rows: 13,
      columns: 26,
      tileWidth: 16,
      tileHeight: 16,
      pos: new Vector(150, 70),
      //   pos: new Vector(0, 0),
    });
    this.frameObject = frameObject;
    this.frameCellSprites = SpriteSheet.fromImageSource({
      image: Resources.FrameCellSprites,
      grid: { rows: 2, columns: 8, spriteHeight: 16, spriteWidth: 16 },
    });
    this.queenCellSprites = SpriteSheet.fromImageSource({
      image: Resources.QueenCellSprites,
      grid: { rows: 1, columns: 5, spriteHeight: 32, spriteWidth: 16 },
    });
    this.emptyCell = this.frameCellSprites.getSprite(0, 0);
    this.eggCell = this.frameCellSprites.getSprite(1, 0);
    this.eggCell1 = this.frameCellSprites.getSprite(2, 0);
    this.larva = this.frameCellSprites.getSprite(3, 0);
    this.larva1 = this.frameCellSprites.getSprite(4, 0);
    this.larva2 = this.frameCellSprites.getSprite(5, 0);
    this.capped1 = this.frameCellSprites.getSprite(6, 0);
    this.capped2 = this.frameCellSprites.getSprite(7, 0);
    this.drone = this.frameCellSprites.getSprite(0, 1);

    this.queenCell4 = this.queenCellSprites.getSprite(0, 0);
    this.wood = this.frameCellSprites.getSprite(7, 1);
    this.honey2 = this.frameCellSprites.getSprite(3, 1);
    this.honey3 = this.frameCellSprites.getSprite(4, 1);
    this.honey1 = this.frameCellSprites.getSprite(2, 1);
    this.honey4 = this.frameCellSprites.getSprite(5, 1);
    this.queenCell0 = this.queenCellSprites.getSprite(1, 0);
    this.queenCell1 = this.queenCellSprites.getSprite(2, 0);
    this.queenCell2 = this.queenCellSprites.getSprite(3, 0);
    this.queenCell3 = this.queenCellSprites.getSprite(4, 0);
    this.queenCellActor = new Actor({ x: 120, y: 210 });
    this.queenCellActor.graphics.add("queenCell0", this.queenCell0);
    this.queenCellActor.graphics.add("queenCell1", this.queenCell1);
    this.queenCellActor.graphics.add("queenCell2", this.queenCell2);
    this.queenCellActor.graphics.add("queenCell3", this.queenCell3);
  }
  drawFrame() {
    for (let tile of this.tiles) {
      const sprite = this.emptyCell;

      if (tile.y == 0) {
        tile.addGraphic(this.wood);
      } else if (tile.x == 1) {
        tile.addGraphic(this.wood);
      } else if (tile.y == 12 && tile.x !== 0 && tile.x !== 25) {
        tile.addGraphic(this.wood);
      } else if (tile.x == 24) {
        tile.addGraphic(this.wood);
      }
    }
  }
  onInitialize() {
    this.drawFrame();
    if (this.frameObject.type == "empty") {
      this.drawFrameContents(emptyFrame, null);
    } else {
      if (this.frameObject.type == "brood") {
        if (this.frameObject.fillCompletion >= 100) {
          this.drawFrameContents(
            broodFrames[this.frameObject.age],
            this.frameObject.queenCell
          );
        } else {
          let completionPercentage = Math.floor(
            this.frameObject.fillCompletion * 10
          );

          this.drawFrameContents(
            partialBrood[completionPercentage],
            this.frameObject.queenCell
          );
        }
      } else if (this.frameObject.type == "honey") {
        if (this.frameObject.fillCompletion >= 100) {
          this.drawFrameContents(honeyFrame, null);
        } else {
          let completionPercentage = Math.floor(
            this.frameObject.fillCompletion * 10
          );

          this.drawFrameContents(partialHoney[completionPercentage], null);
        }
      } else if (this.frameObject.type == "food") {
        if (this.frameObject.fillCompletion >= 100) {
          this.drawFrameContents(honeyFrame, null);
        } else {
          let completionPercentage = Math.floor(
            this.frameObject.fillCompletion * 10
          );

          this.drawFrameContents(partialHoney[completionPercentage], null);
        }
      }
    }
  }
  drawFrameContents(frameData, queenCell) {
    let row = 0;
    let rows = 12;
    let index = 0;
    // for (let tile of this.tiles) {
    //   if (
    //     tile.y !== 0 &&
    //     tile.x !== 1 &&
    //     tile.y !== 12 &&
    //     tile.x !== 0 &&
    //     tile.x !== 25 &&
    //     tile.x !== 24
    //   ) {
    //     //frame contents

    //     tile.addGraphic(this.larva1);
    //     if (index %22 == 0){
    //         row++;
    //         index = 0;
    //     }
    //   }
    // }
    let tilePos = new Vector(2 * 16, 1 * 16);

    let drawn = 0;
    frameData.forEach((row) => {
      Array.from(row).forEach((char) => {
        let rand = Math.random();
        if (drawn % 22 == 0 && drawn !== 0) {
          tilePos.x = 2 * 16;
          tilePos.y += 16;
        } else {
          if (drawn !== 0) {
            tilePos.x += 16;
          }
        }
        drawn++;
        let toDraw = null;
        switch (char) {
          case "e":
            toDraw = this.emptyCell;
            break;
          case "h":
            toDraw = this.honey4;
            break;
          case "1":
            toDraw = this.eggCell;
            break;
          case "2":
            toDraw = this.eggCell1;
            break;
          case "3":
            toDraw = this.larva;
            break;
          case "4":
            if (this.frameObject.spotty > rand) {
              toDraw = this.emptyCell;
            } else {
              toDraw = this.larva1;
            }

            break;
          case "5":
            if (this.frameObject.spotty > rand) {
              toDraw = this.emptyCell;
            } else {
              toDraw = this.larva2;
            }
            break;
          case "6":
            if (this.frameObject.spotty > rand) {
              toDraw = this.emptyCell;
            } else {
              toDraw = this.capped1;
            }
            break;
          case "7":
            if (this.frameObject.spotty > rand) {
              toDraw = this.emptyCell;
            } else {
              toDraw = this.capped2;
            }
            break;

          case "d":
            toDraw = this.drone;
            break;
          default:
            break;
        }

        let tileAdd = this.tiles.find((tile) => {
          return tile.x == tilePos.x / 16 && tile.y == tilePos.y / 16;
        });
        tileAdd.addGraphic(toDraw);
        // map.add([toDraw, k.pos(tilePos)]);
      });
    });

    if (queenCell) {
      this.addChild(this.queenCellActor);

      switch (queenCell.index) {
        case 0:
          this.queenCellActor.graphics.use("queenCell0");
          break;
        case 1:
          this.queenCellActor.graphics.use("queenCell0");

          break;
        case 2:
          this.queenCellActor.graphics.use("queenCell1");

          break;
        case 3:
          this.queenCellActor.graphics.use("queenCell1");

          break;
        case 4:
          this.queenCellActor.graphics.use("queenCell2");

          break;
        case 5:
          this.queenCellActor.graphics.use("queenCell2");
          break;
        case 6:
          this.queenCellActor.graphics.use("queenCell2");
          break;
        case 7:
          this.queenCellActor.graphics.use("queenCell3");
          break;
        case 8:
          this.queenCellActor.graphics.use("queenCell3");
          break;
        case 9:
          this.queenCellActor.graphics.use("queenCell3");
          break;
        default:
          this.queenCellActor.graphics.hide();
          break;
      }
    } else {
      this.queenCellActor.graphics.hide();
    }
  }
  onDestroy() {}
}
